module.exports = __webpack_public_path__ + "/public/images/bbb536773a6bf66947ef093b9c52a1e7.png";